export const environment = {
  production: false,
  webapiUrl: 'http://localhost/Web1/crm/api/v1/'
};
